export default __webpack_public_path__ + "static/media/sandytias.4c6d0b49.jpeg";